








































































import { Component, Inject, Vue } from "vue-property-decorator";
import { FilterOperators, FilterTypes, Sorters } from "@/data/table";
import {
  ITicketsProvider,
  ITicketsProviderMethods
} from "@/models/providers/tickets";
import { IFilter } from "@/models/tables";
import _ from "@/boot/lodash";
import { ListDisplayMode } from "@/data/constants";
import { UserMetaKeys } from "@/data/enums/users";

@Component({
  components: {
    "string-filter": () =>
      import("@/components/app/global/dataFilters/stringFilter.vue")
  }
})
export default class InboxSortControls extends Vue {
  // Inject

  @Inject({ from: "ticketsProvider" })
  public readonly $ticketsProvider!: () => ITicketsProvider;

  @Inject({ from: "ticketsProviderMethods" })
  public readonly $ticketsMethods!: ITicketsProviderMethods;

  // Data

  public isRefreshing = false;
  public availableDisplayModes = [ListDisplayMode.TABLE, ListDisplayMode.INBOX];
  public displayModeStoragePath = UserMetaKeys.UI_SUPPORT_DISPLAY_MODE;
  public displayMode: ListDisplayMode = ListDisplayMode.TABLE;

  // Computed

  public get ticketsProvider() {
    return this.$ticketsProvider();
  }

  public get isInboxLayout() {
    return this.displayMode === ListDisplayMode.INBOX;
  }

  public get inTicketContext() {
    return this.$_.has(this.$route.params, "ticketId");
  }

  public get sorters() {
    return this.ticketsProvider.sorters;
  }

  public get activeSort() {
    const sort = this.ticketsProvider.activeSort;
    return {
      ...sort,
      label: this.$_.get(
        this.$_.find(this.sorters, sorter => sorter.field === sort.field),
        "label"
      ),
      directionLabel:
        sort.direction === Sorters.ASCENDING
          ? this.$t("_.asc")
          : this.$t("_.desc")
    };
  }

  public get sortDirectionIcon() {
    return _.get(this.activeSort, "direction") === Sorters.ASCENDING
      ? "sort-amount-up"
      : "sort-amount-down";
  }

  public get activeReferenceFilter() {
    return _.find(
      this.ticketsProvider.activeFilters,
      filter => filter.key === "reference"
    );
  }

  // Methods

  public applyReferenceFilter(value) {
    this.$ticketsMethods.applyFilters(
      _.compact([
        ..._.filter(
          this.ticketsProvider.activeFilters,
          filter => filter.key !== "reference"
        ),
        ...[
          value
            ? {
                key: "reference",
                label: this.$t("_.reference"),
                type: FilterTypes.STRING,
                operator: FilterOperators.CONTAINS,
                value
              }
            : undefined
        ]
      ]) as IFilter[]
    );
  }

  public async refreshInbox() {
    try {
      this.isRefreshing = true;
      await this.$ticketsMethods.refreshInbox();
    } finally {
      this.isRefreshing = false;
    }
  }
  public toggleSortDirection() {
    const direction =
      this.activeSort.direction === Sorters.ASCENDING
        ? Sorters.DESCENDING
        : Sorters.ASCENDING;
    this.onSortChange(this.activeSort.field, direction);
  }

  public onSortChange(field, direction = this.activeSort.direction) {
    this.$ticketsMethods.applySort(field, direction as Sorters);
  }
}
